module.exports = __webpack_public_path__ + "static/img/map-2.034bf0a3.png";